(function(){
  var toggle=document.querySelector('[data-add-link-toggle]');
  var row=document.querySelector('[data-links-add-item]');
  if(!toggle||!row)return;
  var url=row.querySelector('[data-link-url]');
  var title=row.querySelector('[data-link-title]');

  function scrollRowIntoView(cb){
    var bodyEl=document.querySelector('.atk-workspace__body');
    if(!bodyEl){if(cb)cb();return;}
    var rowRect=row.getBoundingClientRect();
    var bodyRect=bodyEl.getBoundingClientRect();
    var targetTop=bodyEl.scrollTop+(rowRect.top-bodyRect.top)-90;
    var startTop=bodyEl.scrollTop;
    var dist=targetTop-startTop;
    if(Math.abs(dist)<4){if(cb)cb();return;}
    var duration=350,startTime=null;
    function step(ts){
      if(!startTime)startTime=ts;
      var p=Math.min((ts-startTime)/duration,1);
      bodyEl.scrollTop=startTop+dist*(1-Math.pow(1-p,3));
      if(p<1){requestAnimationFrame(step);}else if(cb){cb();}
    }
    requestAnimationFrame(step);
  }

  toggle.addEventListener('click',function(){
    var open=row.classList.toggle('is-open');
    if(open){
      scrollRowIntoView(function(){
        if(url)url.focus({preventScroll:true});
      });
    }
  });

  function syncContent(){
    row.classList.toggle('has-content',!!(url&&url.value.trim().length));
  }
  if(url)url.addEventListener('input',syncContent);
  if(title)title.addEventListener('input',syncContent);

  var addBtn=row.querySelector('[data-link-add]');
  if(addBtn)addBtn.addEventListener('click',function(){
    setTimeout(function(){
      syncContent();
      if(url&&!url.value.trim()){
        row.classList.remove('is-open');
        row.classList.remove('has-content');
        var sec=document.querySelector('[data-ws-module-section="links"]');
        var bodyEl=document.querySelector('.atk-workspace__body');
        if(sec&&bodyEl){
          var secRect=sec.getBoundingClientRect();
          var bodyRect=bodyEl.getBoundingClientRect();
          var targetTop=bodyEl.scrollTop+(secRect.top-bodyRect.top)-16;
          var startTop=bodyEl.scrollTop;
          var dist=targetTop-startTop;
          if(Math.abs(dist)>=4){
            var duration=600,startTime=null;
            function easeScroll(ts){
              if(!startTime)startTime=ts;
              var pr=Math.min((ts-startTime)/duration,1);
              bodyEl.scrollTop=startTop+dist*(1-Math.pow(1-pr,3));
              if(pr<1)requestAnimationFrame(easeScroll);
            }
            requestAnimationFrame(easeScroll);
          }
        }
      }
    },0);
  });
})();

/* Quick Links display: show domain-only titles and site favicons */
(function(){
  function prettify(){
    document.querySelectorAll('.atk-ws-item[data-link-href]').forEach(function(item){
      if(item.getAttribute('data-ast-pretty') === '1') return;
      item.setAttribute('data-ast-pretty', '1');
      var href = item.getAttribute('data-link-href') || '';
      var domain = '';
      try{ domain = new URL(href).hostname; }catch(err){}
      var titleEl = item.querySelector('.atk-workspace__link-title');
      if(titleEl && domain && /^https?:\/\//i.test(titleEl.textContent.trim())){
        titleEl.textContent = domain;
      }
      var iconEl = item.querySelector('.atk-workspace__link-icon');
      if(iconEl && domain && !iconEl.querySelector('img')){
        var img = document.createElement('img');
        img.alt = '';
        img.src = 'https://www.google.com/s2/favicons?domain=' + domain + '&sz=32';
        img.addEventListener('load', function(){
          var svg = iconEl.querySelector('svg');
          if(svg) svg.style.display = 'none';
        });
        img.addEventListener('error', function(){ img.remove(); });
        iconEl.appendChild(img);
      }
    });
  }
  function start(){
    var section = document.querySelector('[data-ws-module-section="links"]');
    if(!section) return;
    prettify();
    new MutationObserver(prettify).observe(section, { childList: true, subtree: true });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
